module.exports = __webpack_public_path__ + "static/media/music.03fa4c2d.svg";